<!-- Barra para adicionar conteudo entre sessoes -->
<template>
    <div :class="[`container-button-add container-button-add--${typeButton}`]">
        <button
          v-if="!isOpen"
          @click="toggleOpen"
          :class="[`button-add button-add--${typeButton} button-add button-add--frame`]"
        >
            <i class="fal fa-plus"></i>
        </button>

        <div
          v-if="isOpen"
          @mouseleave="isOpen = false"
          :class="[`button-add--popover button-add--popover--${typeButton}`, typeModal]"
        >
            <button
                v-for="(button, index) in frameButtons"
                :key="button.index"
                @click="$emit('click', index, referer, card, frame, action)"
                :class="['btn d-flex justify-content-center align-items-center']"
            >
                <i v-if="button.icon" :class="[button.icon]" class="fa-lg"></i>

                <img
                    v-else
                    class="img-svg img-svg-color"
                    src="../../assets/img/icons/before-after.svg"
                />
            </button>
        </div>
    </div>
</template>

<script>

export default {
  name: "AddFrame",
  data() {
    return {
      isOpen: false,

    };
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen;

      this.$emit("return-slot", this.slotNum, this.referer, this.card, this.frame, this.action);
    },
  },
  watch: {
    isOpen(newValue, oldValue) {
      if (newValue) {
        this.$root.$emit('bv::show::popover', 'add-frame')
      } else {
        this.$root.$emit('bv::hide::popover', 'add-frame')
      }
    },
  },
  computed: {
    typeButton() {
      switch (this.type) {
        case 'top':
          return 'top'
        case 'bottom':
          return 'bottom'
        case 'left':
          return 'left'
        case 'right':
          return 'right'
        default:
          return 'bottom'
      }
    },
    typeModal() {
      switch (this.type) {
        case 'top':
          return 'flex-row'
        case 'bottom':
          return 'flex-row'
        case 'left':
          return 'flex-column'
        case 'right':
          return 'flex-column'
        default:
          return 'flex-row'
      }
    }
  },
  props: {
    type: String | null,
    frameButtons: Array | null,
    action: String | null,
    slotNum: Number | null,
    card: String | Number | null,
    frame: String | Number | null,
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/molecules/AddFrame.vue